import { Container } from 'roo-ui/components';
import { useTitleOnMount } from 'lib/hooks/useTitleOnMount';
import PageHeader from 'components/PageHeader';
import Filter from './Filter';
import BookingList from './BookingList';
import BookingListHeading from './BookingListHeading';
import BookingListResultSummary from './BookingListResultSummary';
import { useBookingListContext } from './contextProvider/BookingListContextProvider';
import ErrorPage from '../ErrorPage';
import BookingListAlert from './BookingListAlert';

const BookingListPage = () => {
  useTitleOnMount('Your hotel bookings');
  const { error } = useBookingListContext();

  if (error) {
    return <ErrorPage />;
  }

  return (
    <>
      <PageHeader title="My bookings" />
      <Container>
        <Filter height="48px" width={['100%', '390px']} mt={[6, 10]} />
        <BookingListAlert />
        <BookingListHeading mt={[5, 8]} />
        <BookingListResultSummary mt={[5, 4]} />
        <BookingList mt={[5, 3]} />
      </Container>
    </>
  );
};

export default BookingListPage;
